import { Injectable } from '@angular/core';

@Injectable()
export class Settings{

  base_url: string = "http://web.docker-fin.6f1f7237.svc.dockerapp.io:8000/"
    api_key: string = "1234567"


}



// WEBPACK FOOTER //
// ./src/settings/base.ts